// extracted by mini-css-extract-plugin
module.exports = {"brandImage":"card-brand_brandImage__2v1QH","brandImageDiners":"card-brand_brandImageDiners__2s-vz"};